// Cookie Consent configuration (vanilla-cookieconsent v3.x)
import * as CookieConsent from 'vanilla-cookieconsent';

CookieConsent.run({
    categories: {
        necessary: {
            enabled: true,
            readOnly: true,
        },
        analytics: {
            autoClear: {
                cookies: [
                    { name: /^_ga/ },
                    { name: '_gid' },
                ],
            },
        },
    },

    guiOptions: {
        consentModal: {
            layout: 'cloud',
            position: 'bottom center',
            flipButtons: false,
        },
    },

    language: {
        default: 'cs',
        translations: {
            cs: {
                consentModal: {
                    title: 'Používáme cookies!',
                    description: 'Tyto webové stránky používají základní soubory cookie k zajištění svého správného fungování a analytické soubory cookie k pochopení toho, jak s nimi pracujete. Ty se nastavují pouze po souhlasu.',
                    acceptAllBtn: 'Přijmout vše',
                    acceptNecessaryBtn: 'Odmítnout vše',
                    showPreferencesBtn: 'Nastavení',
                },
                preferencesModal: {
                    title: 'Nastavení cookies',
                    acceptAllBtn: 'Přijmout vše',
                    acceptNecessaryBtn: 'Odmítnout vše',
                    savePreferencesBtn: 'Uložit nastavení',
                    closeIconLabel: 'Zavřít',
                    sections: [
                        {
                            title: 'Využití cookies',
                            description: 'Soubory cookie používáme k zajištění základních funkcí webových stránek a ke zlepšení vašeho online zážitku. U každé kategorie si můžete zvolit, zda se chcete přihlásit nebo odhlásit. Další podrobnosti naleznete v <a href="/privacy.pg" class="cc-link">zásadách ochrany osobních údajů</a>.',
                        },
                        {
                            title: 'Striktně nezbytné cookies',
                            description: 'Tato cookie jsou důležitá pro funkčnost webu. Bez těchto cookies by stránky nefungovaly správně.',
                            linkedCategory: 'necessary',
                        },
                        {
                            title: 'Výkonnostní a analytické cookies',
                            description: 'Tyto cookies nám umožňují zjistit, jak se naše stránky používají a jak je můžeme vylepšit.',
                            linkedCategory: 'analytics',
                            cookieTable: {
                                headers: {
                                    name: 'Jméno',
                                    domain: 'Doména',
                                    expiration: 'Expirace',
                                    description: 'Popis',
                                },
                                body: [
                                    {
                                        name: '_ga',
                                        domain: 'google.com',
                                        expiration: '2 roky',
                                        description: 'Google Analytics (bez inzertních funkcí)',
                                    },
                                    {
                                        name: '_gid',
                                        domain: 'google.com',
                                        expiration: '1 den',
                                        description: 'Google Analytics (bez inzertních funkcí)',
                                    },
                                ],
                            },
                        },
                        {
                            title: 'Více informací',
                            description: 'V případě dotazů v souvislosti s naší politikou vůči souborům cookie a vašimi volbami nás <a class="cc-link" href="/kontakty.php">kontaktujte</a>.',
                        },
                    ],
                },
            },
            en: {
                consentModal: {
                    title: 'We use cookies!',
                    description: 'This website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    showPreferencesBtn: 'Manage preferences',
                },
                preferencesModal: {
                    title: 'Cookie preferences',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Reject all',
                    savePreferencesBtn: 'Save settings',
                    closeIconLabel: 'Close',
                    sections: [
                        {
                            title: 'Cookie usage',
                            description: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want. For more details read the full <a href="/privacy.pg" class="cc-link">privacy policy</a>.',
                        },
                        {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are essential for the proper functioning of the website. Without these cookies, the website would not work properly.',
                            linkedCategory: 'necessary',
                        },
                        {
                            title: 'Performance and Analytics cookies',
                            description: 'These cookies allow the website to remember the choices you have made in the past.',
                            linkedCategory: 'analytics',
                        },
                        {
                            title: 'More information',
                            description: 'For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/kontakty.php">contact us</a>.',
                        },
                    ],
                },
            },
        },
    },
});
